import React from 'react';
import getLogger from '@ignitesales/logger-es';

const logger = getLogger({ component: 'createContext' });

/**
 * Returns array with Context, and useContext hook
 * @param {Object} options
 * @return {Array}
 */
export const createStrictContext = (options = {}) => {
  console.log('making a context', options);
  const Context = React.createContext({});
  Context.displayName = options.name; // for DevTools

  function useContext() {
    const context = React.useContext(Context);
    if (context === undefined) {
      logger.error(
        options.errorMessage || `${name || ''} Context Provider is missing`
      );
    }
    return context;
  }

  return [Context, useContext];
};

export default createStrictContext;
